import { config } from "node-config-ts";
import { useCallback, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import styles from "./app-version.less";

export const AppVersion = () => {
    const version = process.env.REACT_APP_VERSION;
    const [displayAppVersion, setDisplayAppVersion] = useState([
        "local",
        "dev",
        "test",
        "qa1",
        "qa2"
    ].includes(config.APPLICATION_ENVIRONMENT));

    const handleHotKeyPressed = useCallback(() => {
        setDisplayAppVersion(prevDisplayAppVersion => !prevDisplayAppVersion)
    }, [displayAppVersion]);

    useHotkeys("ctrl+shift+k, command+shift+k", handleHotKeyPressed);

    return displayAppVersion ? <div className={styles.appVersion}>v{version}</div> : null
};